module.exports = __webpack_public_path__ + "static/media/spotify-logo.2267a068.png";